import { CLINIC_LOGO } from "../data/site";

// Real clinic logo. Rendered inside a rounded container so it reads cleanly
// on both light (navbar) and dark (footer) backgrounds.
export const Logo = ({ className = "h-11 w-11", light = false }) => (
  <span
    className={`inline-flex items-center justify-center overflow-hidden rounded-xl bg-white ${light ? "ring-1 ring-white/20" : "ring-1 ring-dash-line"} ${className}`}
  >
    <img
      src={CLINIC_LOGO}
      alt="DASH Physiotherapy & Speech and Hearing Clinic logo"
      className="h-full w-full object-cover"
      loading="eager"
    />
  </span>
);
